import React, { ChangeEvent, FunctionComponent, ReactElement, useEffect, useState } from 'react'
import { Button, Radio, Checkbox, Input, Form, Modal, Progress } from 'antd'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { RadioChangeEvent } from 'antd/es/radio'
import { MinusOutlined, CloseOutlined } from '@ant-design/icons'
import { isChangshaGJ } from 'src/commons/utils/Commons'
import {
  AppExit,
  AppInstall,
  AppReallyUninstall,
  AppUninstall,
  PageMini,
  StartMainClient,
  commonJump,
} from 'src/pc/store/UIController'
import {
  ChannelConfigHS,
  DWUserFeedbackHttp,
  DWGetModDataByModIdHttp,
  DWCMSVersionHttp,
} from 'src/commons/store/BasisStore'
import { AppStore } from 'src/pc/store/AppStore'
import { GetChannel, OpenLink } from 'src/commons/utils'
import WarningIcon from 'src/pc/assets/icons/WarningIcon.svg'
import Cookies from 'js-cookie'
// @ts-ignore
import { values } from 'object.values'
import DDImage from '../components/dd-image'
!Object.values && values.shim()

type HomeProps = {}
type UninstallStepProps = {
  GoStep: (step: UninstallStep) => void
}

type NewUninstallStepProps = {
  GoStep: (step: NewUninstallStep) => void
}

type UninstallStep = 0 | 1 | 2 | 3 | 4

const isNewClient = (channelConfig: ChannelConfig | null) => {
  return (
    (channelConfig?.description && channelConfig?.description.indexOf('海鲨游戏') >= 0) ||
    channelConfig?.['wallpaper_shortcut_name']?.includes('管鲨')
  )
}

const StepOneContent = (shortcutName: string): { [key in 1 | 2 | 0]: ReactElement } => {
  return {
    0: (
      <>
        <p>可解决问题：</p>
        <p>加快启动游戏时间，搜索内容错误</p>
        <p>存档工具调不起来，存档时间不准</p>
      </>
    ),
    1: (
      <>
        <p>将下载并安装最新版{shortcutName}，可以解决“启动游戏过慢”等大部分问题</p>
        <span className="Recommend">推荐</span>
      </>
    ),
    2: (
      <>
        <p>卸载{shortcutName}，可能导致您：</p>
        <p>赠送的游戏删除，游戏存档数据丢失</p>
        <p>游戏试玩记录丢失，确定卸载吗？</p>
      </>
    ),
  }
}

const StepOneNextText: { [key in 0 | 1 | 2]: string } = {
  0: '下一步',
  1: '重装客户端',
  2: '继续卸载',
}

const UninstallStepOne: FunctionComponent<UninstallStepProps> = observer(({ GoStep }) => {
  const [UninstallType, setUninstallType] = useState<0 | 1 | 2>(0)
  const ChannelConfig = ChannelConfigHS.SuccessResult

  const UninstallTypeChange = (e: RadioChangeEvent) => {
    setUninstallType(e.target.value)
  }
  const NextStep = () => {
    if (UninstallType === 0) {
      setUninstallType(1)
    } else if (UninstallType === 1) {
      /*重装*/
      AppInstall()
    } else {
      /*卸载*/
      GoStep(1)
    }
  }
  const GoToFeedback = () => {
    GoStep(1)
  }
  return (
    <>
      <main className="StepOne">
        <h1>卸载{ChannelConfig ? ChannelConfig.shortcut_name : ''}？</h1>
        <p>请选择:</p>
        <section>
          <aside>
            <Radio.Group value={UninstallType} onChange={UninstallTypeChange}>
              <Radio value={0}>修复{ChannelConfig ? ChannelConfig.shortcut_name : ''}</Radio>
              <Radio value={1}>重装{ChannelConfig ? ChannelConfig.shortcut_name : ''}</Radio>
              <Radio value={2}>卸载{ChannelConfig ? ChannelConfig.shortcut_name : ''}</Radio>
            </Radio.Group>
            {AppStore.adConfig?.text && (
              <a
                className="ad-text"
                draggable={false}
                {...OpenLink(AppStore.adConfig.textUrl, false, () => window.gogReport?.('BoxClient_unloadone_Click'))}
              >
                {AppStore.adConfig.text}
              </a>
            )}
          </aside>
          <main>{StepOneContent(ChannelConfig ? ChannelConfig.shortcut_name : '')[UninstallType]}</main>
        </section>
      </main>
      <footer>
        <label>
          点击进入{' '}
          <a draggable={false} onClick={GoToFeedback}>
            更多反馈
          </a>
        </label>
        <div>
          {UninstallType === 2 && <Checkbox>删除个人信息，游戏存档数据等信息</Checkbox>}
          <Button onClick={NextStep}>{StepOneNextText[UninstallType]}</Button>
        </div>
      </footer>
    </>
  )
})

const UninstallStepTwo: FunctionComponent<UninstallStepProps> = ({ GoStep }) => {
  const [Reason, setReason] = useState<string[]>([])
  const [Opinion, setOpinion] = useState<string>()
  const [Contact, setContact] = useState<string>()
  const ChannelConfig = ChannelConfigHS.SuccessResult
  const GoPreStep = () => {
    GoStep(0)
  }
  const FeedBackAndUninstall = () => {
    Modal.confirm({
      title: '卸载可能使端内您所拥有的游戏数据丢失',
      centered: true,
      className: 'custom ConfirmUninstall' + (isNewClient(ChannelConfig) ? ' newConfirmUninstall' : ''),
      width: 280,
      icon: (
        <i className="anticon" style={{ color: isNewClient(ChannelConfig) ? '' : '#FB5244' }}>
          <WarningIcon />
        </i>
      ),
      onCancel: () => {
        const userReportInfo = Cookies.get('userReportInfo')
        let mobile = ''
        if (userReportInfo) {
          mobile = JSON.parse(userReportInfo).mobile
        }
        DWUserFeedbackHttp.Execute({
          channel: GetChannel(),
          type: 8,
          content: Opinion?.trim() || undefined,
          mobile: mobile || Contact?.trim() || undefined,
          title: Reason.join(';'),
        })
        GoStep(2)
        AppUninstall()
      },
      onOk: () => {
        StartMainClient()
        AppExit()
      },
      okText: '我所拥有的游戏',
      cancelText: '确认卸载',
    })
  }
  const ReasonChange = (checkedValue: string[]) => {
    setReason(checkedValue)
  }
  const OpinionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setOpinion(e.target.value)
  }
  const ContactChange = (e: ChangeEvent<HTMLInputElement>) => {
    setContact(e.target.value)
  }
  return (
    <>
      <main className="StepTwo">
        <h1>您的反馈让我们更专业</h1>
        <Form className="custom">
          <Form.Item>
            <Checkbox.Group value={Reason} onChange={ReasonChange}>
              <Checkbox value="找不到想玩的游戏或账号">找不到想玩的游戏或账号</Checkbox>
              <Checkbox value="下单后无法上号">下单后无法上号</Checkbox>
              <Checkbox value="登号不会用">登号不会用</Checkbox>
              <Checkbox value="之前玩的游戏不玩了">之前玩的游戏不玩了</Checkbox>
              <Checkbox value="杀毒软件报毒">杀毒软件报毒</Checkbox>
              <Checkbox value="不想再用别人的账号了">不想再用别人的账号了</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item>
            <Input.TextArea
              value={Opinion}
              placeholder="请提出您宝贵的意见，我一定认真阅读并改进！"
              maxLength={200}
              rows={3}
              onChange={OpinionChange}
            />
          </Form.Item>
          <Form.Item label="您的联系方式">
            <Input value={Contact} onChange={ContactChange} maxLength={50} />
          </Form.Item>
        </Form>
      </main>
      <footer>
        <div />
        <div>
          <Button onClick={GoPreStep}>上一步</Button>
          <Button onClick={FeedBackAndUninstall}>继续卸载</Button>
        </div>
      </footer>
    </>
  )
}

const UninstallStepThree: FunctionComponent<UninstallStepProps> = observer(({ GoStep }) => {
  const ChannelConfig = ChannelConfigHS.SuccessResult
  useEffect(() => {
    if (AppStore.UninstallInfo?.percent === 100) {
      GoStep(3)
    }
  }, [AppStore.UninstallInfo?.percent])
  return (
    <>
      <main className="StepThree">{ChannelConfig && <img draggable={false} src={ChannelConfig.logo} />}</main>
      <footer>
        <Progress percent={AppStore.UninstallInfo?.percent} showInfo={false} strokeWidth={4} />
        <p>
          {AppStore.UninstallInfo?.dir} 正在卸载....
          <span>{AppStore.UninstallInfo?.percent}%</span>
        </p>
      </footer>
    </>
  )
})

const UninstallStepFour: FunctionComponent<UninstallStepProps> = ({ GoStep }) => {
  const ChannelConfig = ChannelConfigHS.SuccessResult
  const GoNextStep = () => {
    GoStep(4)
  }
  return (
    <main className="StepFive">
      <h1>{ChannelConfig ? ChannelConfig.shortcut_name : ''}正式版已卸载完毕</h1>
      <h2>
        感谢您的使用，我们将继续创造更好的游戏体验，欢迎您再次体验{ChannelConfig ? ChannelConfig.shortcut_name : ''}！
      </h2>
      <p>
        <Button type="primary" onClick={GoNextStep}>
          完成
        </Button>
      </p>
    </main>
  )
}

const UninstallStepFive = () => {
  const ChannelConfig = ChannelConfigHS.SuccessResult
  return (
    <main className="StepFour">
      <h1>{ChannelConfig ? ChannelConfig.shortcut_name : ''}感谢您的一路陪伴</h1>
      <h2>再相见我已不是曾经的我，何不再试一次？</h2>
      <p>
        <Button
          onClick={() => {
            if (AppStore.adConfig?.lastText) {
              window.gogReport?.('BoxClient_unloadlast_Click')
              commonJump(AppStore.adConfig.lastTextUrl, true)
            }
            AppReallyUninstall()
          }}
        >
          {AppStore.adConfig?.lastText ? AppStore.adConfig.lastText : '再见'}
        </Button>
        <Button type="primary" onClick={AppInstall}>
          安装新版本
        </Button>
      </p>
    </main>
  )
}

const UninstallStepContent = (GoStep: (step: UninstallStep) => void): { [key in UninstallStep]: ReactElement } => {
  return {
    0: <UninstallStepOne GoStep={GoStep} />,
    1: <UninstallStepTwo GoStep={GoStep} />,
    2: <UninstallStepThree GoStep={GoStep} />,
    3: <UninstallStepFour GoStep={GoStep} />,
    4: <UninstallStepFive />,
  }
}

type NewUninstallStep = 0 | 1

const NewUninstallStepTwo: FunctionComponent<{ finalUninstallPercent: number }> = observer(
  ({ finalUninstallPercent }) => {
    const ChannelConfig = ChannelConfigHS.SuccessResult
    useEffect(() => {
      let host
      if (isChangshaGJ) {
        host = 'https://www.steamvipmall.com/'
      } else if (process.env.BUILD_TYPE === 'prodUninstall') {
        host = 'https://www.99box.com/'
      } else {
        host = 'http://www-new.test.99box.com/'
        // host = 'http://localhost:3000/'
      }
      if (finalUninstallPercent === 100) {
        window.FuluApp!.JSNotifyCppFunc(
          'open_url',
          isChangshaGJ ? `${host}client-uninstall-page` : `${host}client-uninstall-page`,
        )
        setTimeout(() => {
          AppReallyUninstall()
        }, 3000)
      }
    }, [finalUninstallPercent])
    return (
      <>
        <main className="StepThree">{ChannelConfig && <img draggable={false} src={ChannelConfig.logo} />}</main>
        <footer>
          <Progress percent={finalUninstallPercent} showInfo={false} strokeWidth={4} />
          <p>
            {AppStore.UninstallInfo?.dir} 正在卸载....
            <span>{finalUninstallPercent}%</span>
          </p>
        </footer>
      </>
    )
  },
)

const NewUninstallStepOne: FunctionComponent<{ onConfirm: () => void }> = ({ onConfirm }) => {
  return (
    <main className="StepFour">
      <h1 style={{ marginTop: 36 }}>请再次确认您希望进行的操作</h1>
      <h2 style={{ width: 450, margin: '15px auto 0' }}>
        卸载平台后您在平台保存的云存档将全部丢失。注意: [修复平台]
        可以在大多数情况下解决共享账号无法正常使用，游戏平台无法正常登录等问题
      </h2>
      <p style={{ marginTop: 36 }}>
        <Button
          onClick={() => {
            onConfirm()
          }}
        >
          继续卸载
        </Button>
        <Button type="primary" onClick={AppInstall}>
          修复平台
        </Button>
      </p>
    </main>
  )
}

const Home: FunctionComponent<HomeProps> = () => {
  const [UninstallStep, setUninstallStep] = useState<NewUninstallStep>(0)
  const [finalUninstallPercent, setFinalUninstallPercent] = useState<number>(0)
  const [silentInstallStatus, setSilentInstallStatus] = useState<
    'waitInit' | 'notNeedSilentInstall' | 'waitSilentInstall'
  >('waitInit')
  const ChannelConfig = ChannelConfigHS.SuccessResult

  const handleStep1Confirm = () => {
    setUninstallStep(1)
    AppUninstall()
  }

  const getConfig = async () => {
    const cmsVersionResult = await DWCMSVersionHttp.Execute()
    const version = `${cmsVersionResult}_${location.host}`
    try {
      const [adConfig, uninstallAdConfig, uninstallJumpConfig] = await Promise.all([
        DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_uninstall_ad_config', version }),
        DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_uninstall_adconfig', version }),
        DWGetModDataByModIdHttp.Execute({ modId: 'simpleclient_uninstall_jump_config', version }),
      ])
      AppStore.adConfig = adConfig?.datas?.[0]?.properties
      AppStore.uninstallSilentDownloadConfig =
        uninstallAdConfig?.datas?.map(d => d.properties).filter(f => !!f.type && f.type === 'download' && !!f.url) || []
      AppStore.uninstallJumpConfig.ids =
        uninstallJumpConfig?.datas?.[0]?.properties?.silent_install_ids?.split(',') || []
      const currentUserId = Cookies.get('current_userid')
      const userIdLastNum = currentUserId ? currentUserId[currentUserId.length - 1] : undefined
      const needSilentInstall =
        AppStore.uninstallSilentDownloadConfig.length > 0 &&
        userIdLastNum &&
        currentUserId &&
        AppStore.uninstallJumpConfig.ids.includes(userIdLastNum)
      if (needSilentInstall) {
        setSilentInstallStatus('waitSilentInstall')
      } else {
        setSilentInstallStatus('notNeedSilentInstall')
      }
    } catch (error) {
      setSilentInstallStatus('notNeedSilentInstall')
    }
  }

  useEffect(() => {
    let clientUninstallPercent: number
    let uninstallSilentInstallSuccess: number
    if (silentInstallStatus === 'waitSilentInstall' || silentInstallStatus === 'waitInit') {
      clientUninstallPercent = (AppStore.UninstallInfo?.percent || 0) * 0.99
      uninstallSilentInstallSuccess = AppStore.uninstallSilentInstallSuccess ? 1 : 0
    } else {
      clientUninstallPercent = AppStore.UninstallInfo?.percent || 0
      uninstallSilentInstallSuccess = 0
    }
    setFinalUninstallPercent(Number((clientUninstallPercent + uninstallSilentInstallSuccess).toFixed(1)))
  }, [AppStore.UninstallInfo?.percent, AppStore.uninstallSilentInstallSuccess, silentInstallStatus])

  useEffect(() => {
    if (silentInstallStatus === 'waitSilentInstall' && UninstallStep === 1) {
      window.FuluApp!.JSNotifyCppFunc(
        'silent_install',
        JSON.stringify({ install: AppStore.uninstallSilentDownloadConfig.map(d => ({ url: d.url })) }),
      )
    }
  }, [silentInstallStatus, UninstallStep])

  useEffect(() => {
    getConfig()
  }, [])

  return (
    <div id="Uninstall" className={`${isNewClient(ChannelConfig) ? 'new' : ''} Step${UninstallStep}`}>
      <header>
        <div>
          {/*{ChannelConfig && <img draggable={false}  src={ChannelConfig.logo} />}*/}
          <label>卸载游戏管家提示</label>
        </div>
        <div>
          <a draggable={false} style={{ zIndex: 2, position: 'relative' }} onClick={PageMini}>
            <MinusOutlined />
          </a>
          <a draggable={false} style={{ zIndex: 2, position: 'relative' }} onClick={AppExit}>
            <CloseOutlined />
          </a>
        </div>
      </header>
      {UninstallStep === 0 && <NewUninstallStepOne onConfirm={handleStep1Confirm} />}
      {UninstallStep === 1 && <NewUninstallStepTwo finalUninstallPercent={finalUninstallPercent} />}
    </div>
  )
}

export default hot(observer(Home))
